import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { BaseServices } from './../../kuba.services';
import { Vehicle } from './../models/vehicle';
import { VehicleServices } from './vehicle.service';

@Injectable()
export class VehicleListResolver {
  constructor(private backend: VehicleServices) {}

  resolve(route: ActivatedRouteSnapshot): Observable<Vehicle[]> {
    return this.backend.getAllVehicles();
  }
}

@Injectable()
export class VehicleEditResolver {
  constructor(private backend: VehicleServices) {}

  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getVehiclesById(+route.params['id']);
  }
}

@Injectable()
export class VehicleFeaturesResolver {
  constructor(private backend: VehicleServices) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.backend.getVehicleFeatures(BaseServices.BusinessId);
  }
}

@Injectable()
export class VehicleListResolverByUserResolver {
  constructor(private backend: VehicleServices) {}

  resolve(route: ActivatedRouteSnapshot): Observable<Vehicle[]> {
    return this.backend.getUserVehicles(BaseServices.UserId);
  }
}
